/* nv-app.js
   Einziges Skript des Themes. Keine Bibliothek, kein externer Abruf.
   Aufgabe: Auf- und Zuklappen der Navigation auf dem Handy. */

(function () {
  'use strict';

  function initNav(root) {
    var toggle = root.querySelector('.nv-header__toggle');
    var panel = root.querySelector('.nv-header__panel');
    if (!toggle || !panel) {
      return;
    }

    function setOpen(open) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
      root.classList.toggle('nv-header--open', open);
      document.documentElement.style.overflow = open ? 'hidden' : '';
    }

    setOpen(false);

    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      setOpen(!open);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') {
        return;
      }
      if (toggle.getAttribute('aria-expanded') === 'true') {
        setOpen(false);
        toggle.focus();
      }
    });

    /* Beim Wechsel auf breite Bildschirme wird das Panel wieder Teil der
       Kopfleiste; der gesperrte Bildlauf muss dann aufgehoben werden. */
    var wide = window.matchMedia('(min-width: 768px)');
    var onChange = function (event) {
      if (event.matches) {
        setOpen(false);
      }
    };
    if (typeof wide.addEventListener === 'function') {
      wide.addEventListener('change', onChange);
    } else if (typeof wide.addListener === 'function') {
      wide.addListener(onChange);
    }
  }

  function boot() {
    var headers = document.querySelectorAll('.nv-header');
    for (var i = 0; i < headers.length; i += 1) {
      initNav(headers[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Der Theme-Editor baut Sections neu auf; danach erneut binden. */
  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target.querySelector('.nv-header');
    if (target) {
      initNav(target);
    }
  });
})();

/* Heldenvideo: laeuft stumm in Schleife. Wer im Betriebssystem Bewegung
   reduziert hat, bekommt das erste Einzelbild als Standbild. */
(function () {
  'use strict';

  function syncHeroVideo() {
    var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var videos = document.querySelectorAll('[data-nv-hero-video]');
    for (var i = 0; i < videos.length; i += 1) {
      var v = videos[i];
      if (ruhig) {
        v.autoplay = false;
        v.loop = false;
        v.pause();
        try {
          v.currentTime = 0;
        } catch (e) {
          /* Einzelbild noch nicht geladen, dann bleibt das Vorschaubild stehen */
        }
      } else if (v.paused) {
        var p = v.play();
        if (p && typeof p.catch === 'function') {
          p.catch(function () {
            /* Der Browser hat den Start verweigert, das Vorschaubild bleibt */
          });
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncHeroVideo);
  } else {
    syncHeroVideo();
  }

  window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', syncHeroVideo);
  document.addEventListener('shopify:section:load', syncHeroVideo);
})();

/* Konfigurator: Fragenstrecke, Mengenberechnung und Warenkorbuebergabe.
   Alle Daten kommen serverseitig aus den Konfigurator-Optionen des Shops. */
(function () {
  'use strict';

  function euro(cents) {
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }

  function initConfigurator(root) {
    var dataEl = root.querySelector('[data-nv-configurator-data]');
    if (!dataEl) {
      return;
    }

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }

    var steps = root.querySelectorAll('[data-nv-step]');
    var progress = root.querySelectorAll('[data-nv-progress]');
    var state = { step: 0, scenario: 'blackout', persons: 1, days: 5, level: 'basis', rows: [], beratung: false, extras: [], begruendung: null };

    function show(index) {
      state.step = index;
      for (var i = 0; i < steps.length; i += 1) {
        steps[i].hidden = Number(steps[i].dataset.nvStep) !== index;
      }
      for (var p = 0; p < progress.length; p += 1) {
        if (Number(progress[p].dataset.nvProgress) === index) {
          progress[p].setAttribute('data-nv-current', 'true');
        } else {
          progress[p].removeAttribute('data-nv-current');
        }
      }
      var zahl = root.querySelector('[data-nv-schrittzahl]');
      if (zahl) {
        zahl.textContent = 'Schritt ' + (index + 1) + ' von ' + steps.length;
      }
    }

    function menge(handle) {
      var regel = data.reichweiten[handle];
      if (!regel) {
        return 1;
      }
      var personentage = state.persons * state.days;
      if (regel.einheit === 'kcal') {
        return Math.ceil((personentage * data.kcalProTag) / regel.menge);
      }
      if (regel.einheit === 'tage') {
        return state.persons * Math.ceil(state.days / regel.menge);
      }
      if (regel.einheit === 'liter') {
        return Math.ceil((personentage * data.literProTag) / regel.menge);
      }
      if (regel.einheit === 'person') {
        return state.persons;
      }
      return 1;
    }

    function auswaehlen() {
      var bedarf = state.persons * state.days;
      state.beratung = false;
      state.rows = [];
      state.extras = [];
      state.begruendung = null;

      if (!data.boxen || !data.boxen.length || !state.days || !state.persons) {
        return;
      }

      if (bedarf > 20) {
        state.beratung = true;
        return;
      }

      var boxen = data.boxen.filter(function (b) {
        return b.verfuegbar && b.personentage > 0;
      });
      if (!boxen.length) {
        state.beratung = true;
        return;
      }

      var beste = null;
      var mengen = [];
      var alleTreffer = [];

      function suche(index, deckung, preis, stueck) {
        if (stueck > 4) {
          return;
        }
        if (index === boxen.length) {
          if (stueck === 0 || deckung < bedarf) {
            return;
          }
          if (!beste || preis < beste.preis || (preis === beste.preis && deckung < beste.deckung)) {
            beste = { preis: preis, deckung: deckung, mengen: mengen.slice() };
          }
          alleTreffer.push({ preis: preis, deckung: deckung, mengen: mengen.slice() });
          return;
        }
        for (var m = 0; m <= 7; m++) {
          mengen[index] = m;
          suche(index + 1, deckung + m * boxen[index].personentage, preis + m * boxen[index].preis, stueck + m);
        }
        mengen[index] = 0;
      }

      suche(0, 0, 0, 0);

      if (!beste) {
        state.beratung = true;
        return;
      }

      var zweitPreis = null;
      alleTreffer.forEach(function (t) {
        if (t.preis <= beste.preis) { return; }
        if (zweitPreis === null || t.preis < zweitPreis) { zweitPreis = t.preis; }
      });

      var jePT = Math.round(beste.preis / beste.deckung);
      state.begruendung = {
        preis: beste.preis,
        deckung: beste.deckung,
        jePT: jePT,
        alternative: null
      };
      if (zweitPreis !== null && zweitPreis >= beste.preis * 1.05) {
        state.begruendung.alternative = zweitPreis;
      }

      boxen.forEach(function (box, i) {
        if (!beste.mengen[i]) {
          return;
        }
        state.rows.push({
          handle: box.handle,
          titel: box.titel,
          url: box.url,
          variante: box.variante,
          preis: box.preis,
          verfuegbar: true,
          bereich: 'Deckt ' + box.personentage + ' Personentage',
          menge: beste.mengen[i],
          lebensmittel: false,
          vegetarisch: false,
          an: true
        });
      });

      var stufenfolge = ['basis', 'erweitert', 'profi'];
      var stufengrenze = stufenfolge.indexOf(state.level);
      if (data.ergaenzungen && data.ergaenzungen.length && state.scenario && stufengrenze >= 0) {
        data.ergaenzungen.forEach(function (e) {
          if (!e.verfuegbar) {
            return;
          }
          var rang = stufenfolge.indexOf(e.stufe);
          if (rang < 0 || rang > stufengrenze) {
            return;
          }
          var liste = String(e.szenarien).split(',');
          var passt = false;
          for (var i = 0; i < liste.length; i += 1) {
            if (liste[i].replace(/^\s+|\s+$/g, '') === state.scenario) {
              passt = true;
            }
          }
          if (!passt) {
            return;
          }
          state.extras.push({
            titel: e.titel,
            url: e.url,
            variante: e.variante,
            preis: e.preis,
            bereich: e.bereich,
            menge: 1,
            verfuegbar: true,
            an: false
          });
        });
      }
    }

    function zeichnen() {
      var liste = root.querySelector('[data-nv-result]');
      var leer = root.querySelector('[data-nv-empty]');
      var summe = root.querySelector('[data-nv-total]');
      var zusammenfassung = root.querySelector('[data-nv-summary]');
      var beratung = root.querySelector('[data-nv-beratung]');
      var extras = root.querySelector('[data-nv-extras]');
      var extrasListe = root.querySelector('[data-nv-extras-liste]');
      var begruendung = root.querySelector('[data-nv-begruendung]');
      var szenario = root.querySelector('[data-nv-szenario]');
      if (!liste) {
        return;
      }

      liste.textContent = '';
      leer.hidden = state.rows.length > 0;

      if (beratung) {
        beratung.hidden = !state.beratung;
      }
      if (szenario) {
        szenario.hidden = state.beratung;
      }
      if (leer) {
        leer.hidden = state.rows.length > 0 || state.beratung;
      }
      var knopf = root.querySelector('[data-nv-cart]');
      if (knopf) {
        knopf.hidden = state.beratung;
      }
      if (summe) {
        summe.hidden = state.beratung;
      }

      if (begruendung) {
        if (state.beratung || !state.begruendung) {
          begruendung.hidden = true;
          begruendung.textContent = '';
        } else {
          var b = state.begruendung;
          var satz = euro(b.preis) + ' für ' + b.deckung
            + ' Personentage — ' + euro(b.jePT) + ' je Person und Tag.';
          if (b.alternative) {
            satz += ' Die nächstgünstigere Zusammenstellung kostet '
              + euro(b.alternative) + '.';
          }
          begruendung.textContent = satz;
          begruendung.hidden = false;
        }
      }

      var premium = root.querySelector('[data-nv-premium]');
      if (premium) {
        premium.textContent = '';
        premium.hidden = true;
        if (!state.beratung && data.premium && data.premium.verfuegbar
            && state.rows.length === 1
            && state.rows[0].menge === 1
            && state.rows[0].handle === data.premium.ersetzt
            && data.premium.preis > state.rows[0].preis) {
          var auf = data.premium.preis - state.rows[0].preis;
          var a = document.createElement('a');
          a.href = data.premium.url;
          a.textContent = data.premium.titel;
          premium.appendChild(document.createTextNode('Dieselbe Reichweite gibt es auch als '));
          premium.appendChild(a);
          premium.appendChild(document.createTextNode(
            ' für ' + euro(data.premium.preis) + ' — ' + euro(auf)
            + ' mehr, dafür ' + data.premium.zusatz + '.'));
          premium.hidden = false;
        }
      }

      state.rows.forEach(function (row, index) {
        var li = document.createElement('li');
        li.className = 'nv-configurator__item';
        if (!row.verfuegbar) {
          li.setAttribute('data-nv-sold-out', 'true');
        }

        var box = document.createElement('input');
        box.type = 'checkbox';
        box.className = 'nv-configurator__check';
        box.checked = true;
        box.setAttribute('aria-label', 'Diese Box ist gesetzt');
        box.setAttribute('aria-disabled', 'true');
        box.classList.add('nv-configurator__check--fest');
        box.addEventListener('click', function (event) {
          event.preventDefault();
        });

        var body = document.createElement('div');
        body.className = 'nv-configurator__item-body';

        var link = document.createElement('a');
        link.className = 'nv-configurator__item-title';
        link.href = row.url;
        link.textContent = row.titel;

        var meta = document.createElement('span');
        meta.className = 'nv-configurator__item-meta';
        meta.textContent = row.bereich + ' — ' + row.menge + ' Stück'
          + (row.verfuegbar ? '' : ' — zurzeit nicht verfügbar');

        var preis = document.createElement('span');
        preis.className = 'nv-configurator__item-price';
        preis.textContent = euro(row.preis * row.menge);

        body.appendChild(link);
        body.appendChild(meta);
        li.appendChild(box);
        li.appendChild(body);
        li.appendChild(preis);
        liste.appendChild(li);
      });

      if (zusammenfassung) {
        zusammenfassung.textContent = state.persons + (state.persons === 1 ? ' Person, ' : ' Personen, ')
          + state.days + (state.days === 1 ? ' Tag' : ' Tage');
      }
      if (extras) {
        extras.hidden = state.beratung || state.extras.length === 0;
      }
      if (extrasListe) {
        extrasListe.textContent = '';
        state.extras.forEach(function (row, index) {
          var li = document.createElement('li');
          li.className = 'nv-configurator__item';

          var haken = document.createElement('input');
          haken.type = 'checkbox';
          haken.className = 'nv-configurator__check';
          haken.checked = row.an;
          haken.addEventListener('change', function () {
            state.extras[index].an = haken.checked;
            summeZeichnen();
          });

          var body = document.createElement('div');
          body.className = 'nv-configurator__item-body';

          var link = document.createElement('a');
          link.className = 'nv-configurator__item-title';
          link.href = row.url;
          link.textContent = row.titel;

          var meta = document.createElement('span');
          meta.className = 'nv-configurator__item-meta';
          meta.textContent = row.bereich;

          var preis = document.createElement('span');
          preis.className = 'nv-configurator__item-price';
          preis.textContent = euro(row.preis);

          body.appendChild(link);
          body.appendChild(meta);
          li.appendChild(haken);
          li.appendChild(body);
          li.appendChild(preis);
          extrasListe.appendChild(li);
        });
      }
      summeZeichnen();

      function summeZeichnen() {
        var gesamt = 0;
        state.rows.forEach(function (row) {
          if (row.an && row.verfuegbar) {
            gesamt += row.preis * row.menge;
          }
        });
        state.extras.forEach(function (row) {
          if (row.an) {
            gesamt += row.preis * row.menge;
          }
        });

        if (!summe) {
          return;
        }
        summe.textContent = 'Summe: ' + euro(gesamt);
      }
    }

    root.addEventListener('click', function (event) {
      var choice = event.target.closest('[data-nv-choice]');
      if (choice) {
        var feld = choice.dataset.nvChoice;
        state[feld] = feld === 'days' ? Number(choice.dataset.nvValue) : choice.dataset.nvValue;
        var geschwister = root.querySelectorAll('[data-nv-choice="' + feld + '"]');
        for (var i = 0; i < geschwister.length; i += 1) {
          geschwister[i].setAttribute('aria-pressed', geschwister[i] === choice ? 'true' : 'false');
        }
        if (feld === 'scenario') {
          auswaehlen();
          zeichnen();
          return;
        }
        if (feld === 'level') {
          auswaehlen();
          zeichnen();
          show(3);
        } else {
          show(state.step + 1);
        }
        return;
      }

      var nav = event.target.closest('[data-nv-nav]');
      if (nav) {
        if (nav.dataset.nvNav === 'back') {
          show(Math.max(0, state.step - 1));
        } else {
          var ziel = Math.min(steps.length - 1, state.step + 1);
          if (ziel === 3) {
            auswaehlen();
            zeichnen();
          }
          show(ziel);
        }
        return;
      }

      var cart = event.target.closest('[data-nv-cart]');
      if (cart) {
        inDenWarenkorb(cart);
      }
    });

    var personsInput = root.querySelector('[data-nv-input="persons"]');
    if (personsInput) {
      personsInput.addEventListener('change', function () {
        var wert = parseInt(personsInput.value, 10);
        state.persons = isNaN(wert) ? 1 : Math.min(10, Math.max(1, wert));
        personsInput.value = state.persons;
      });
    }

    function inDenWarenkorb(button) {
      var status = root.querySelector('[data-nv-status]');
      var items = state.rows
        .filter(function (row) { return row.an && row.verfuegbar && row.menge > 0; })
        .map(function (row) { return { id: row.variante, quantity: row.menge }; });

      state.extras.forEach(function (row) {
        if (row.an && row.verfuegbar && row.menge > 0) {
          items.push({ id: row.variante, quantity: row.menge });
        }
      });

      if (items.length === 0) {
        if (status) { status.textContent = 'Es ist nichts ausgewählt.'; }
        return;
      }

      button.disabled = true;
      if (status) { status.textContent = 'Wird hinzugefügt …'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) { throw new Error('cart'); }
          return res.json();
        })
        .then(function () {
          if (status) {
            status.textContent = items.length + ' Positionen liegen im Warenkorb.';
          }
          window.location.href = data.cartUrl;
        })
        .catch(function () {
          button.disabled = false;
          if (status) {
            status.textContent = 'Das hat nicht geklappt. Bitte noch einmal versuchen.';
          }
        });
    }

    show(0);
  }

  function bootConfigurator() {
    var roots = document.querySelectorAll('.nv-configurator');
    for (var i = 0; i < roots.length; i += 1) {
      initConfigurator(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootConfigurator);
  } else {
    bootConfigurator();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target.querySelector('.nv-configurator');
    if (target) {
      initConfigurator(target);
    }
  });
})();

/* Preis folgt der Variantenauswahl.
   Ohne dieses Skript bleibt der Kopfpreis auf der zuerst verfuegbaren Variante
   stehen, waehrend das Auswahlfeld daneben eine andere nennt — zwei
   widersprechende Preise auf einem Bildschirm. Die Werte stehen als
   data-Attribute an den Optionen, es wird nichts nachgeladen. */
(function () {
  var bereiche = document.querySelectorAll('[data-nv-preis-bereich]');
  for (var i = 0; i < bereiche.length; i++) {
    (function (bereich) {
      var sel = bereich.querySelector('select[name="id"]');
      var wert = bereich.querySelector('[data-nv-preis-wert]');
      if (!sel || !wert) { return; }
      var grund = bereich.querySelector('[data-nv-preis-grund]');
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        if (!opt) { return; }
        wert.textContent = opt.getAttribute('data-nv-preis') || wert.textContent;
        if (grund) {
          var g = opt.getAttribute('data-nv-grund') || '';
          grund.textContent = g;
          grund.hidden = g === '';
        }
      });
    }(bereiche[i]));
  }
})();
